import { call, put, select, takeLatest } from "redux-saga/effects";

import { createUser, updateCustomerData, EmailLogin, EmailOtpVerify, loginUser } from "./UserApis";
import * as ACTIONS from "./UserAction";
import {
  dispatchSnackbarError,
  dispatchSnackbarSuccess,
} from "../../utils/Shared";
import * as TYPES from "./UserTypes";
import { useSelector } from "react-redux";
import History from "../../routes/History";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { firebaseAuth } from "../../firebase";

// Replace with your sagas
export function* sagasCreateUser({ payload }) {
  try {
    console.log("Creating user with payload:", payload);
    const response = yield call(createUser, payload);
    // console.log("User creation response:", response);
    yield put(ACTIONS.getUser({ ...response }));

    if (response) {
      dispatchSnackbarSuccess("User details updated");
    }
  } catch (err) {
    console.error("User creation error:", err);
    console.error("Error response:", err.response);
    console.error("Error message:", err.message);
    
    // Try to get more specific error message
    let errorMessage = "Something went wrong, please try again later";
    
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.response?.data?.error) {
      errorMessage = err.response.data.error;
    } else if (err.message && err.message !== "Something went wrong!") {
      errorMessage = err.message;
    }
    
    dispatchSnackbarError(errorMessage);
  }
}

export function* sagasUpdateCustomerData({ payload }) {
  try {
    // console.log("Updating customer data with payload:", payload);
    const response = yield call(updateCustomerData, payload);
    // console.log("Customer data update response:", response);
    yield put(ACTIONS.getUser({ ...response }));

    if (response) {
      // Check if this is just an address update to prevent redirection
      if (payload?.isAddressUpdate) {
        dispatchSnackbarSuccess("Address updated successfully");
      } else {
        dispatchSnackbarSuccess("Profile updated successfully");
      }
    }
  } catch (err) {
    console.error("Customer data update error:", err);
    console.error("Error response:", err.response);
    console.error("Error message:", err.message);
    
    // Try to get more specific error message
    let errorMessage = "Something went wrong, please try again later";
    
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.response?.data?.error) {
      errorMessage = err.response.data.error;
    } else if (err.message && err.message !== "Something went wrong!") {
      errorMessage = err.message;
    }
    
    dispatchSnackbarError(errorMessage);
  }
}

export function* sagasLoginUser({ payload }) {
  try {
    const response = yield call(loginUser, payload);
    if (response) {
      yield put(ACTIONS.getUser(response));
      // console.log("response", response);
      dispatchSnackbarSuccess("Login Successfully");
      // payload.cbl();

      if (payload?.isDirectLogin) {
        History.push(`/${payload?.hotelKey}/profile`);
      }
    }
    // } else {
    //   payload.cbs();
    //   // dispatchSnackbarError("Account with this phone number does not exists!");
    // }
  } catch (err) {
    console.log("error ", err);
    // dispatchSnackbarError(err.response.data);
    dispatchSnackbarError("Something went wrong, please try again later");
  }
}

export function* sagasEmailLogin({ payload }) {
  // console.log("payload in sagaaaaa", payload);
  try {
    if (payload?.setLoading) payload.setLoading(true);
    const response = yield call(EmailLogin, payload);
    console.log("Email login response:", response);

    if (response?.status === 200) {
      // Call the callback to change the form type to "otp"
      if (payload?.onSuccess) {
        payload.onSuccess();
      }
      dispatchSnackbarSuccess("OTP sent to your email");
      // Additional logic if needed, like getting user info, etc.
    } else {
      console.log("Email login failed with status:", response?.status);
      dispatchSnackbarError(response?.data?.message || response?.data?.error || "Failed to send OTP. Please try again.");
    }
  } catch (err) {
    console.error("Email login error:", err);
    console.error("Error details:", {
      message: err.message,
      response: err.response,
      stack: err.stack
    });
    
    let errorMessage = "Something went wrong, please try again later";
    
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.response?.data?.error) {
      errorMessage = err.response.data.error;
    }
    
    dispatchSnackbarError(errorMessage);
  } finally {
    // Stop loading
    if (payload?.setLoading) payload.setLoading(false);
  }
}

export function* sagasEmailOtpRequest({ payload }) {
  // console.log("payload in saga", payload);

  try {
    if (payload?.setLoading) payload.setLoading(true);
    const response = yield call(EmailOtpVerify, payload); // Call your API for OTP verification
  

    // Check if response is an error response (API returns error?.response instead of throwing)
    if (!response || response.status >= 400) {
 
      dispatchSnackbarError(response?.data?.message || response?.data?.error || "Invalid OTP. Please try again.");
      return;
    }

    if (response?.status === 200 || response?.status === 201) {
      const { customToken, customer } = response?.data;
      // console.log("custom tokennnnn", customToken);

      if (customToken) {
        try {
          // Get Firebase Auth instance
          const auth = getAuth();

          // Wait for the Firebase authentication to resolve
          const userCredential = yield call(
            signInWithCustomToken,
            auth,
            customToken
          );

          // Firebase sign-in success
          const user = userCredential.user;
          // console.log("Firebase sign-in success:", user);

          // Check if customer exists
          if (customer) {
            // console.log("customer found");
            // If customer exists, change formType to null (successful login)
            yield put(ACTIONS.getUser(customer)); // Dispatch user action if needed
            dispatchSnackbarSuccess("Login Successfully");

            if (payload?.changeFormType) {
              payload.changeFormType(null); // Set formType to null on success
            }
          } else {
            // console.log("customer not found", user);

            // Set customer UID in the login form values (callback from the component)
            if (payload?.setCustomerUid) {
              payload.setCustomerUid(user?.uid); // Send UID back to the component
            }

            // If no customer, change formType to signup (user needs to complete signup)
            if (payload?.changeFormType) {
              payload.changeFormType("signup");
            }
          }
        } catch (firebaseError) {
          console.error("Firebase sign-in error:", firebaseError);
          dispatchSnackbarError(
            "Failed to sign in with Firebase. Please try again."
          );
        }
      } else {
        // console.log("responseeeeee in sagaaaaaa", response);
        if (payload?.changeFormType) {
          payload.changeFormType(null); // Set formType to null on success
        }
        // if (payload?.setLoading) payload.setLoading(false);
        dispatchSnackbarError("No customer Token,OTP verification failed ");
      }
    } else {
     
      dispatchSnackbarError(response?.data?.message || response?.data?.error || "OTP verification failed. Please try again.");
    }
  } catch (err) {

 
    
    // Provide more specific error message based on error type
    let errorMessage = "Something went wrong, please try again later";
    
    if (err.message && err.message.includes("Firebase")) {
      errorMessage = "Authentication failed. Please try again.";
    } else if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.response?.data?.error) {
      errorMessage = err.response.data.error;
    }
    
    dispatchSnackbarError(errorMessage);
  } finally {
    if (payload?.setLoading) payload.setLoading(false);
  }
}

export function* CreateUserSaga() {
  yield takeLatest(TYPES.CREATE_USER_REQUEST, sagasCreateUser);
}

export function* UpdateCustomerDataSaga() {
  yield takeLatest(TYPES.UPDATE_CUSTOMER_DATA_REQUEST, sagasUpdateCustomerData);
}

export function* LoginUserSaga() {
  yield takeLatest(TYPES.LOGIN_USER_REQUEST, sagasLoginUser);
}

export function* EmailLoginSaga() {
  yield takeLatest(TYPES.EMAIL_LOGIN_REQUEST, sagasEmailLogin);
}

export function* EmailOtpRequestSaga() {
  yield takeLatest(TYPES.EMAIL_OTP_REQUEST, sagasEmailOtpRequest);
}
